import React from "react";
import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import FormField from "layouts/pages/account/components/FormField";
import SettingsCard from "./SettingsCard";
import {
  FONT_OPTIONS,
  FONT_SIZE_OPTIONS,
  FONT_DROPDOWN_STYLE,
  FONT_SIZE_DROPDOWN_STYLE,
} from "./constants/fontConstants";

const TopbarStylingSection = ({ inputData }) => {
  return (
    <SettingsCard
      title="Topbar Styling"
      subtitle="Customize your topbar appearance"
      gridProps={{
        xs: 12,
        sx: {
          "@media (min-width: 1100px)": {
            flexBasis: "calc(50% - 12px)",
            maxWidth: "calc(50% - 12px)",
            width: "calc(50% - 12px)"
          }
        }
      }}
    >
      <Grid container spacing={2.5}>
        <Grid item xs={12}>
          <FormField
            defaultValue={inputData?.topbar_bg || "#ffffff"}
            className="color-input"
            label="Topbar Background Color"
            name="topbar_bg"
            inputProps={{ type: "color" }}
          />
        </Grid>

        <Grid item xs={12}>
          <FormField
            defaultValue={inputData?.topbar_text || "#113861"}
            className="color-input"
            label="Topbar Text Color"
            name="topbar_text"
            inputProps={{ type: "color" }}
          />
        </Grid>

        <Grid item xs={12}>
          <SoftBox display="flex" gap={1}>
            <SoftBox flex={1} display="flex" flexDirection="column">
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  Topbar Font
                </SoftTypography>
              </SoftBox>
              <select
                name="topbar_font"
                defaultValue={inputData?.topbar_font || "Poppins"}
                style={FONT_DROPDOWN_STYLE}
              >
                {FONT_OPTIONS.map((font) => (
                  <option key={font} value={font}>
                    {font}
                  </option>
                ))}
              </select>
            </SoftBox>
            <SoftBox display="flex" flexDirection="column" style={{ width: "80px" }}>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  Font Size
                </SoftTypography>
              </SoftBox>
              <select
                name="topbar_font_size"
                defaultValue={inputData?.topbar_font_size || "16px"}
                style={FONT_SIZE_DROPDOWN_STYLE}
              >
                {FONT_SIZE_OPTIONS.slice(0, 6).map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
            </SoftBox>
          </SoftBox>
        </Grid>
      </Grid>
    </SettingsCard>
  );
};

export default TopbarStylingSection;
